<template>
  <div class="container">
    <img :src="banner1" alt class="banner1" />
    <div class="xxxbutton" @click="goLocation"></div>
    <div class="xboxxkz">
      <div class="x1">
        <el-image :src="lx1"></el-image>
        <div class="button" @click="goLocation"></div>
      </div>
      <div class="x2">
        <el-image :src="lx2"></el-image>

        <div class="button1" @click="goLocation"></div>
        <div class="button2" @click="goLocation"></div>
        <div class="button3" @click="goLocation"></div>
        <div class="button4" @click="goLocation"></div>
      </div>
      <div class="x3">
        <div class="title">预约办理 专享服务</div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item prop="name">
            <el-input v-model="ruleForm.name" class="input" type="text" placeholder="请填写您要办理的许可证"></el-input>
          </el-form-item>
          <el-form-item prop="phone">
            <el-input v-model="ruleForm.phone" class="input" type="text" placeholder="请输入您的联系方式" />
          </el-form-item>
          <el-form-item>
            <div class="xx">
              <el-button class="yy" @click="submitForm('ruleForm')">立即预约</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="contentxkz">
      <div class="title">
        <div class="text">常见许可证代办</div>
        <div class="line">
          <div class="line_box"></div>
        </div>
      </div>

      <div class="cjlx">
        <div class="box">
          <div class="box_item border">
            <img :src="icon1" alt class="icon" />
            <img :src="icon1h" alt class="iconh" />
            <div class="head">食品经营许可证</div>
            <div class="body">
              从事食品经营、
              餐饮服务、单位食堂等需办理
            </div>
            <div class="button" @click="goLocation">详情咨询</div>
          </div>
          <div class="box_item borderm">
            <img :src="icon2" alt class="icon" />
            <img :src="icon2h" alt class="iconh" />
            <div class="head">卫生许可证</div>
            <div class="body">
              除餐饮外，涉及到美容、
              美发、按摩等需办理卫生许可证
            </div>
            <div class="button" @click="goLocation">详情咨询</div>
          </div>
          <div class="box_item border">
            <img :src="icon3" alt class="icon" />
            <img :src="icon3h" alt class="iconh" />
            <div class="head">道路运输许可证</div>
            <div class="body">
              从事客运、货运
              行业需办理道路运输许可证
            </div>
            <div class="button" @click="goLocation">详情咨询</div>
          </div>
        </div>
        <div class="box">
          <div class="box_item">
            <img :src="icon4" alt class="icon" />
            <img :src="icon4h" alt class="iconh" />
            <div class="head">烟草专卖许可证</div>
            <div class="body">
              经营烟草制品，
              必须按要求办理烟草专卖许可证
            </div>
            <div class="button" @click="goLocation">详情咨询</div>
          </div>
          <div class="box_item bordermm">
            <img :src="icon5" alt class="icon" />
            <img :src="icon5h" alt class="iconh" />
            <div class="head">医疗器械许可证</div>
            <div class="body">
              经营医疗器械、医院
              或者其他医疗机构，需要办理许可证
            </div>
            <div class="button" @click="goLocation">详情咨询</div>
          </div>
          <div class="box_item">
            <img :src="icon6" alt class="icon" />
            <img :src="icon6h" alt class="iconh" />
            <div class="head">网络文化许可证</div>
            <div class="body">
              提供互联网文化产品
              及其服务的企业，都需要办理许可证
            </div>
            <div class="button" @click="goLocation">详情咨询</div>
          </div>
        </div>
      </div>

      <div class="qtlx">
        <div class="boxf">
          <img :src="qtlximg" alt />
          <div class="button" @click="goLocation"></div>
        </div>
        <div class="box">
          <div class="boxz">
            <div class="box_item">
              <img :src="pczicon1" alt class="icon" />
              <img :src="pczicon1" alt class="iconx" />
              <div class="text">劳务派遣许可证</div>
              <div class="button" @click="goLocation">详情咨询</div>
            </div>
            <div class="box_item">
              <img :src="pczicon2" alt class="icon" />
              <img :src="pczicon2" alt class="iconx" />
              <div class="text">人力资源许可证</div>
              <div class="button" @click="goLocation">详情咨询</div>
            </div>
            <div class="box_item">
              <img :src="pczicon3" alt class="icon" />
              <img :src="pczicon3" alt class="iconx" />
              <div class="text">出版印刷许可证</div>
              <div class="button" @click="goLocation">详情咨询</div>
            </div>
          </div>
          <div class="boxz">
            <div class="box_item">
              <img :src="pczicon4" alt class="icon" />
              <img :src="pczicon4" alt class="iconx" />
              <div class="text">进出口许可证</div>
              <div class="button" @click="goLocation">详情咨询</div>
            </div>
            <div class="box_item">
              <img :src="pczicon5" alt class="icon" />
              <img :src="pczicon5" alt class="iconx" />
              <div class="text">ICP许可证</div>
              <div class="button" @click="goLocation">详情咨询</div>
            </div>
            <div class="box_item">
              <img :src="pczicon6" alt class="icon" />
              <img :src="pczicon6" alt class="iconx" />
              <div class="text">城市垃圾回收清理</div>
              <div class="button" @click="goLocation">详情咨询</div>
            </div>
          </div>
        </div>
      </div>
      <img :src="banner2" alt class="banner" />
      <img :src="banner3" alt class="banner" />
      <div style="margin-top:60px"></div>
      <div class="title">
        <div class="text">一次选择，安心拿证</div>
        <div class="line">
          <div class="line_box"></div>
        </div>
      </div>

      <div class="anxin">
        <div class="box_item">
          <div class="num">01</div>
          <div class="list">
            <div class="icon"></div>
            <div class="text">15天快速取证</div>
          </div>
          <div class="line"></div>
          <div class="body">从咨询到领证全程加急</div>
          <div class="button" @click="goLocation">办理咨询 ></div>
        </div>
        <div class="box_item">
          <div class="num">02</div>
          <div class="list">
            <div class="icon"></div>
            <div class="text">代办费用更低</div>
          </div>
          <div class="line"></div>
          <div class="body">比同行低30%，远低于您自己办理花去的时间成本。</div>
          <div class="button" @click="goLocation">办理咨询 ></div>
        </div>
        <div class="box_item">
          <div class="num">03</div>
          <div class="list">
            <div class="icon"></div>
            <div class="text">不成功不收费</div>
          </div>
          <div class="line"></div>
          <div class="body">集团给予保障，确保客户利益</div>
          <div class="button" @click="goLocation">办理咨询 ></div>
        </div>
        <div class="box_item">
          <div class="num">04</div>
          <div class="list">
            <div class="icon"></div>
            <div class="text">专业度更高</div>
          </div>
          <div class="line"></div>
          <div class="body">专业顾问从业经验高达10年，熟悉办事流程和规则</div>
          <div class="button" @click="goLocation">办理咨询 ></div>
        </div>
      </div>
    </div>

    <div class="clxkz">
      <div class="title">
        <div class="text">亿源小揽服务承诺</div>
        <div class="line">
          <div class="line_box"></div>
        </div>
      </div>
      <div class="box">
        <div class="boxs">
          <div class="boxs_item">
            <img :src="clicon1" alt class="icon" />
            <div class="head">一对一服务</div>
            <div class="body">专业顾问、专享服务，24小时，随时咨询各类工商政策，文件，资料送到家。</div>
          </div>
          <div class="boxs_item border">
            <img :src="clicon2" alt class="icon" />
            <div class="head">透明无差价</div>
            <div class="body">亿源提供高品质服务，收费透明，无隐性收费，价格比同行低30%。</div>
          </div>
          <div class="boxs_item">
            <img :src="clicon3" alt class="icon" />
            <div class="head">售后有保障</div>
            <div class="body">集团公司，实力更强，360度全方位服务，责任到人，出错赔付。</div>
          </div>
        </div>
        <div class="line"></div>
        <div class="button" @click="goLocation">免费咨询</div>
      </div>
    </div>

    <div class="ryczxkz">
      <div class="ry">
        <el-image class="img" :src="rybg"></el-image>

        <div class="rycontent">
          <div class="title">亿源小揽的荣誉</div>
          <div class="little">专业创造价值 · 奋斗改变世界</div>
          <iframe
            class="item"
            name="child"
            id="child"
            width="auto"
            height="300"
            frameborder="0"
            scrolling="no"
            style="width:100%;height:500px;"
            src="certify-swiper4/pcry.html"
          ></iframe>
        </div>
      </div>

      <div class="cz">
        <div class="title">
          <div class="head">10年辉煌 共筑企业成长</div>
          <div class="little">亿源小揽10年累计服务超过30万客户</div>
        </div>
        <div class="czcontent">
          <iframe
            name="child"
            id="child"
            width="auto"
            height="300"
            frameborder="0"
            scrolling="no"
            style="width:100%;height:500px;"
            src="certify-swiper4/pccz.html"
          ></iframe>
        </div>
      </div>
    </div>
    <el-drawer size="100%" :visible.sync="drawer" :direction="direction">
      <iframe
        name="child"
        id="child"
        frameborder="0"
        scrolling="no"
        style="width:100%;height:100%;"
        src="https://ala.zoosnet.net/LR/Chatpre.aspx?id=ALA47434699&lng=cn"
      ></iframe>
    </el-drawer>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      ruleForm: {
        name: "",
        phone: ""
      },
      rules: {
        name: [
          { required: true, message: "请填写您要办理的许可证", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入电话号码", trigger: "blur" },
          { min: 11, max: 11, message: "请输入正确的电话号码", trigger: "blur" }
        ]
      },
      direction: "rtl",
      drawer: false,
      pczicon1: require("../../../assets/xkz/pczicon1.png"),
      pczicon2: require("../../../assets/xkz/pczicon2.png"),
      pczicon3: require("../../../assets/xkz/pczicon3.png"),
      pczicon4: require("../../../assets/xkz/pczicon4.png"),
      pczicon5: require("../../../assets/xkz/pczicon5.png"),
      pczicon6: require("../../../assets/xkz/pczicon6.png"),
      qtlximg: require("../../../assets/xkz/pcqt.png"),
      icon1h: require("../../../assets/xkz/icon1.png"),
      icon2h: require("../../../assets/xkz/icon2.png"),
      icon3h: require("../../../assets/xkz/icon3.png"),
      icon4h: require("../../../assets/xkz/icon4.png"),
      icon5h: require("../../../assets/xkz/icon5.png"),
      icon6h: require("../../../assets/xkz/icon6.png"),
      icon1: require("../../../assets/xkz/icon1h.png"),
      icon2: require("../../../assets/xkz/icon2h.png"),
      icon3: require("../../../assets/xkz/icon3h.png"),
      icon4: require("../../../assets/xkz/icon4h.png"),
      icon5: require("../../../assets/xkz/icon5h.png"),
      icon6: require("../../../assets/xkz/icon6h.png"),
      clicon1: require("../../../assets/xkz/clicon1.png"),
      clicon2: require("../../../assets/xkz/clicon2.png"),
      clicon3: require("../../../assets/xkz/clicon3.png"),
      lx1: require("../../../assets/xkz/pcqtdb.png"),
      lx2: require("../../../assets/xkz/pctc.png"),
      banner1: require("../../../assets/xkz/pcbanner1.png"),
      banner2: require("../../../assets/xkz/pcbanner2.png"),
      banner3: require("../../../assets/xkz/pcbanner3.png"),
      rybg: require("../../../assets/xkz/rybg.png")
    };
  },
  mounted() {
    if (this._isMobile()) {
      // alert("手机端");
      window.location.href = "http://m.18soo.net/nt/#/xkz";
    }
  },
  methods: {
    goLocation(){
      window.location.href = 'https://ala.zoosnet.net/LR/Chatpre.aspx?id=ALA47434699&lng=cn'
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 发送 POST 请求
          axios({
            method: "post",
            url: "http://www.18soo.net/nextpro/send",
            data: {
              name: this.ruleForm.name,
              phone: this.ruleForm.phone
            }
          })
            .then(res => {
              if (res.data.code == 200) {
                alert("提交成功");
              } else {
                alert("提交失败");
              }
            })
            .catch(() => {
              alert("提交失败");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.container {
  min-width: 1920px;
  background: #ffffff;
  width: 100%;
  position: relative;

  .banner1 {
    width: 100%;
  }
  .xxxbutton {
    position: absolute;
    top: 448px;
    left: 470px;
    width: 318px;
    height: 71px; 
    cursor: pointer;
  }
  .xboxxkz {
    margin-top: 65px;
    margin-bottom: 65px;
    background: #ffffff;
    display: flex;
    flex-direction: row;
    justify-content: center;
    .x1 {
      margin-right: 27px;
      margin-top: 5px;
      position: relative;
      .button {
        position: absolute;
        cursor: pointer;
        width: 130px;
        height: 50px;
        top: 210px;
        left: 10px;
      }
    }
    .x2 {
      position: relative;
      .button1 {
        position: absolute;
        cursor: pointer;
        width: 35px;
        height: 35px;
        top: 153px;
        left: 220px;
      }
      .button2 {
        position: absolute;
        cursor: pointer;
        width: 35px;
        height: 35px;
        top: 153px;
        left: 520px;
      }
      .button3 {
        position: absolute;
        cursor: pointer;
        width: 35px;
        height: 35px;
        top: 370px;
        left: 220px;
      }
      .button4 {
        position: absolute;
        cursor: pointer;
        width: 35px;
        height: 35px;
        top: 370px;
        left: 520px;
      }
    }
    .x3 {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-left: 20px;
      margin-top: 10px;
      width: 336px;
      height: 396px;
      background: #ffffff;
      border: 1px solid #e9f3ff;
      box-shadow: 4px 6px 16px 0px #e9f2ff;
      .title {
        margin-bottom: 20px;
        width: 270px;
        height: 29px;
        font-size: 28px;
        font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
        font-weight: bold;
        text-align: left;
        color: #7791e9;
        line-height: 30px;
        letter-spacing: 3px;
      }
      .input .el-input__inner {
        margin-top: 9px;
        margin-bottom: 9px;
        width: 279px;
        height: 39px;
        background: #ffffff;
        border: 1px solid #ebebeb;
        border-radius: 20px;
        font-size: 15px;
        font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
        font-weight: 400;
        text-align: center;
        color: #cacaca;
        line-height: 12px;
        letter-spacing: 3px;
      }
      .xx {
        text-align: center;
        .yy {
          width: 155px;
          height: 38px;
          background: #7791e9;
          border-radius: 19px;
          font-family: FZLTTHJW -GB1-0, FZLTTHJW -GB1-0--GB1-0;
          font-weight: -GB1-0;
          text-align: center;
          color: #ffffff;
          letter-spacing: 4px;
        }
      }
    }
  }
  .contentxkz {
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .title {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .text {
        font-size: 37px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(91, 93, 101, 1);
      }
      .line {
        margin-bottom: 60px;
        margin-top: 15px;
        width: 419px;
        height: 5px;
        background: #c3c3c3;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        .line_box {
          position: absolute;
          width: 60px;
          height: 9px;
          background: #fea816;
        }
      }
    }

    .banner {
      width: 100%;
    }
    .cjlx {
      margin-bottom: 60px;
      .box {
        display: flex;
        flex-direction: row;
        .border {
          border-bottom: 1px dashed #cacaca;
        }
        .borderm {
          border-bottom: 1px dashed #cacaca;

          border-left: 1px dashed #cacaca;
          border-right: 1px dashed #cacaca;
        }
        .bordermm {
          border-left: 1px dashed #cacaca;
          border-right: 1px dashed #cacaca;
        }
        .box_item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 393px;
          height: 259px;
          .icon {
            height: 70px;
            width: auto;
            margin-top: 30px;
          }
          .iconh {
            height: 0;
            width: 0;
          }
          .head {
            margin-top: 26px;
            width: 167px;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: rgba(81, 81, 81, 1);
            text-align: center;
            line-height: 35px;
          }
          .body {
            margin-top: 13px;
            width: 280px;
            height: 80px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            text-align: center;
            font-weight: bold;
            color: rgba(189, 189, 189, 1);
            line-height: 25px;
          }
          .button {
            cursor: pointer;
            width: 73px;
            text-align: center;
            border: 1px solid #415185;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #2965e0;
            margin-top: 20px;
            line-height: 27px;
            margin-bottom: 40px;
          }
        }

        .box_item:hover {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 393px;
          height: 259px;
          background: #2f89fd;
          .icon {
            height: 0;
            width: 0;
            margin-top: 40px;
          }
          .iconh {
            height: 70px;
            width: auto;
          }
          .head {
            margin-top: 26px;
            width: 167px;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #fbff00;
            text-align: center;
            line-height: 35px;
          }
          .body {
            margin-top: 13px;
            width: 280px;
            height: 80px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            text-align: center;
            font-weight: bold;
            color: #ffffff;
            line-height: 25px;
          }
          .button {
            cursor: pointer;
            width: 73px;
            text-align: center;
            border: 1px solid #ffffff;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            margin-top: 20px;
            line-height: 27px;
            margin-bottom: 40px;
          }
        }
      }
    }
    .qtlx {
      margin-top: 60px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .boxf {
        position: relative;
        .button {
          cursor: pointer;
          position: absolute;
          width: 138px;
          height: 48px;
          top: 245px;
          left: 35px;
        }
      }
      .boxz {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        .box_item {
          width: 295px;
          height: 177px;
          background: #ffffff;
          box-shadow: 2px 4px 18px 0px #e9f2ff;
          border-radius: 10px;
          margin: 18px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .icon {
            height: 66px;
            width: auto;
          }
          .iconx {
            height: 0;
            width: 0;
          }
          .text {
            margin: 20px;
            font-size: 21px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: rgba(81, 81, 81, 1);
            line-height: 36px;
          }
          .button {
            opacity: 0;
            width: 100%;
            height: 0px;
            background: #2f89fd;
            border-radius: 10px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: rgba(255, 255, 255, 1);
            line-height: 34px;
            text-align: center;
          }
        }
        .box_item:hover {
          width: 295px;
          height: 177px;
          background: #ffffff;
          box-shadow: 2px 4px 18px 0px #e9f2ff;
          border-radius: 10px;
          margin: 18px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .icon {
            height: 0;
            width: 0;
          }
          .iconx {
            height: 66px;
            width: auto;
          }
          .text {
            margin: 20px;
            font-size: 21px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: rgba(81, 81, 81, 1);
            line-height: 36px;
          }
          .button {
            opacity: 1;
            cursor: pointer;
            width: 100%;
            height: 40px;
            background: #2f89fd;
            border-radius: 10px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: rgba(255, 255, 255, 1);
            line-height: 34px;
            text-align: center;
          }
        }
      }
    }
    .anxin {
      top: 300px;
      flex-direction: row;
      display: flex;
      margin-bottom: 60px;
      .box_item {
        position: relative;
        margin: 25px;
        width: 309px;
        height: 406px;

        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(228, 228, 228, 1);
        box-shadow: 2px 4px 9px 0px rgba(37, 37, 37, 0.1);
        border-radius: 10px;
        .num {
          text-align: right;
          width: 280px;
          height: 100px;
          font-size: 56px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: rgba(153, 185, 255, 1);
        }
        .list {
          height: 50px;
          display: flex;
          flex-direction: row;
          align-items: center;
          .icon {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: rgba(91, 94, 102, 1);
            margin: 10px;
          }
          .text {
            height: 27px;
            font-size: 26px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(91, 94, 102, 1);
            line-height: 28px;
          }
        }
        .line {
          height: 1px;
          width: 90%;
          margin: 5%;
          border-top: 1px dashed #000000;
        }
        .body {
          margin: 5%;
          height: 17px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(177, 177, 177, 1);
          line-height: 28px;
        }
        .button {
          cursor: pointer;
          position: absolute;
          bottom: 70px;
          left: 25px;
          text-align: center;
          width: 103px;
          height: 34px;
          background: rgba(87, 209, 253, 1);
          border-radius: 14px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 34px;
        }
      }
      .box_item:hover {
        position: relative;
        margin: 25px;
        width: 309px;
        height: 406px;

        background: #0072ff;
        border: 1px solid rgba(228, 228, 228, 1);
        box-shadow: 2px 4px 9px 0px rgba(37, 37, 37, 0.1);
        border-radius: 10px;
        .num {
          text-align: right;
          width: 280px;
          height: 100px;
          font-size: 56px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #ffffff;
        }
        .list {
          height: 50px;
          display: flex;
          flex-direction: row;
          align-items: center;
          .icon {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #ffffff;
            margin: 10px;
          }
          .text {
            height: 27px;
            font-size: 26px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            line-height: 28px;
          }
        }
        .line {
          height: 1px;
          width: 90%;
          margin: 5%;
          border-top: 1px dashed #ffffff;
        }
        .body {
          margin: 5%;
          height: 17px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 28px;
        }
        .button {
          cursor: pointer;
          position: absolute;
          bottom: 70px;
          left: 25px;
          text-align: center;
          width: 103px;
          height: 34px;
          background: #ffffff;
          border-radius: 14px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #777777;
          line-height: 34px;
        }
      }
    }
  }

  .clxkz {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .title {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .text {
        font-size: 37px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(91, 93, 101, 1);
      }
      .line {
        margin-bottom: 60px;
        margin-top: 15px;
        width: 419px;
        height: 5px;
        background: #c3c3c3;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        .line_box {
          position: absolute;
          width: 60px;
          height: 9px;
          background: #fea816;
        }
      }
    }
    .box {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .boxs {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .boxs_item {
          width: 339px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .icon {
            height: 80px;
          }
          .head {
            margin-top: 20px;
            margin-bottom: 32px;
            width: 125px;
            font-size: 25px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            line-height: 34px;
          }
          .body {
            width: 241px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(117, 117, 117, 1);
            line-height: 20px;
            margin-bottom: 60px;
          }
        }
        .border {
          border-left: 1px dotted #000000;
          border-right: 1px dotted #000000;
        }
      }
      .line {
        height: 1px;
        width: 100%;
        border-bottom: 1px dotted #000000;
      }
      .button {
        cursor: pointer;
        margin-top: 60px;
        margin-bottom: 100px;
        text-align: center;
        width: 137px;
        height: 52px;
        background: #ffa900;
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 52px;
      }
    }
  }
  .ryczxkz {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .ry {
      position: relative;
      width: 100%;
      .img {
        width: 100%;
      }
      .rycontent {
        position: absolute;
        top: 60px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background: none;
        .title {
          width: auto;
          height: 50px;
          font-size: 50px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          line-height: 49px;
          margin-bottom: 30px;
          position: relative;

          .gxbox {
            width: 45px;
            height: 34px;
            position: absolute;
            right: 0px;
            bottom: 0px;
          }
        }

        .little {
          font-size: 18px;
          font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
          font-weight: 400;
          text-align: center;
          color: rgba(255, 255, 255, 1);
          letter-spacing: 2px;
        }
      }
    }
    .cz {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 700px;
      .title {
        margin-bottom: 100px;
        position: relative;
        .head {
          margin-top: 67px;
          margin-bottom: 16px;
          height: 50px;
          font-size: 50px;
          font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
          font-weight: bold;
          text-align: center;
          color: #4a4a4a;
          line-height: 48px;
          letter-spacing: 5px;
          position: relative;

          .gxbox {
            width: 45px;
            height: 34px;
            position: absolute;
            right: 0px;
            bottom: 0px;
          }
        }
        .little {
          height: 19px;
          font-size: 18px;
          font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
          font-weight: 400;
          text-align: center;
          color: #363636;
          line-height: 37px;
          letter-spacing: 2px;
        }
      }
    }
  }
}
</style>